export const state = {
  benchmarks: [],
  channels: [],
  pageGroups: [],
  colorList: [],
};
